import { useHTTP } from "@soft-db/http/vue";
import { inject, type InjectionKey, provide, ref } from "vue";

function createSyncDate() {
	const offset = ref(0);

	const now = () => Date.now() + offset.value;
	const date = () => new Date(now());

	const http = useHTTP();
	const sync = async () => {
		const beforeRequest = Date.now();
		const ntp = await http.get<number>("/ntp");
		const afterRequest = Date.now();
		offset.value = (ntp - beforeRequest + (ntp - afterRequest)) / 2;
	};

	return { offset, now, date, sync };
}

const SyncDateSymbol: InjectionKey<ReturnType<typeof createSyncDate>> = Symbol();

export const provideSyncDate = () => {
	const syncDate = createSyncDate();

	provide(SyncDateSymbol, syncDate);

	return syncDate;
};

export const useSyncDate = () => {
	const syncDate = inject(SyncDateSymbol);
	if (!syncDate) throw new Error("Sync Date must be used in the vue app");

	return syncDate;
};
